import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { FileUploadModalComponent } from '../../../shared/modals/file-upload-modal/file-upload-modal.component';
import { TablistService, tabModel } from '../tablist.service';


@Injectable({
  providedIn: 'root'
})
export class FileUploadModalService {
  givenMiniIndex: number = 0;
  documents: any;
  @Output() modelChanged = new EventEmitter<any>();

  openTabs: tabModel[] = [];

  constructor(private modalService: NgbModal, private modal2: NgbModalConfig,
    private tablistService: TablistService) {
  }

  openModal(model?: any, other?: any, entityName?: string) {
    var modalRef!: NgbModalRef;

    modalRef = this.modalService.open(FileUploadModalComponent, { size: 'lg', centered: true, windowClass: "openModal", backdropClass: 'static', backdrop: 'static', keyboard: false, scrollable: true });
    modalRef.componentInstance.service = model;
    modalRef.componentInstance.givenMiniIndex = this.givenMiniIndex;
    modalRef.componentInstance.entityName = entityName;
    this.givenMiniIndex += 1;

    if (other) {
      modalRef.componentInstance.entityFileUpload.entityId = other.entityId;
      modalRef.componentInstance.entityFileUpload.entityTypeId = other.entityTypeId;
    }


    var miniSub:Subscription = modalRef.componentInstance.minimize.subscribe((result: any) => {
      var documentItem: any;

      if (result.minimize) {
        documentItem = <HTMLElement>document.getElementsByClassName("openModal").item(0);
        documentItem.id = `FileUpload${modalRef.componentInstance.givenMiniIndex}`;
        documentItem.className += " miniModal"
        documentItem.classList.remove("openModal");  
        documentItem.classList.remove("animateGrow");

        var newtab = new tabModel();
        newtab.name = `${result.name}`;
        newtab.elementId = `FileUpload${result.index}`;
        newtab.model = modalRef.componentInstance.service
        this.tablistService.createTab(newtab);
        this.disableBackground()
      }

      var sub: Subscription = modalRef.closed.subscribe(() => {
        this.disableBackground();
        this.modelChanged.emit({ filesToAdd: modalRef.componentInstance.entityFileUpload.fileIdsToAdd, files: modalRef.componentInstance.files });
        sub.unsubscribe();
      });
      
      var sub: Subscription = modalRef.dismissed.subscribe(() => {
        this.disableBackground();
        sub.unsubscribe();
      })
    });

    var sub: Subscription = modalRef.closed.subscribe(() => {
      this.disableBackground();
      this.modelChanged.emit({ filesToAdd: modalRef.componentInstance.entityFileUpload.fileIdsToAdd, files: modalRef.componentInstance.files });
      sub.unsubscribe();
    });

    var sub: Subscription = modalRef.dismissed.subscribe(() => {
      this.disableBackground();
      sub.unsubscribe();
    })
  }

  private disableBackground() {
    this.documents = document.getElementsByClassName("static");
    this.documents.forEach((element: any) => {
      element.className += " noBackgroundForModal"
      element.classList.remove("static")
    });
  }
}